import { Component, input, output } from '@angular/core';

import { PrivaButtonComponent } from '@priva/components/button';
import { PrivaContentHeaderComponent } from '@priva/components/content-header';
import { PrivaContentSectionComponent } from '@priva/components/content-section';
import { PrivaContentTemplateComponent } from '@priva/components/content-template';
import { PrivaHeaderComponent } from '@priva/components/header';
import { PrivaLocalizationModule } from '@priva/localization';

import { ActivityType } from 'app/shared/features/activity-selector/models';
import { MeasurementType } from 'app/shared/models/measurement-type';

@Component({
    selector: 'app-terminal-overlay',
    templateUrl: './terminal-overlay.component.html',
    styleUrl: './terminal-overlay.component.scss',
    imports: [
        PrivaButtonComponent,
        PrivaContentHeaderComponent,
        PrivaContentTemplateComponent,
        PrivaContentSectionComponent,
        PrivaHeaderComponent,
        PrivaLocalizationModule,
    ],
})
export class TerminalOverlayComponent {
    title = input<string>('');
    subtitle = input<string>('');
    icon = input<string>('');
    activityType = input<ActivityType | undefined>(ActivityType.Generic);
    measurementType = input<MeasurementType | undefined>(MeasurementType.noMeasurementType);
    isFinishVisible = input<boolean>(true);

    closeRequested = output<void>();
    finishRequested = output<void>();

    isPackingActivity(): boolean {
        return this.activityType() === ActivityType.Packing && this.isFinishVisible();
    }

    isContainerMeasurement(): boolean {
        return this.measurementType() !== MeasurementType.noMeasurementType;
    }

    close(): void {
        this.closeRequested.emit();
    }

    finish(): void {
        this.finishRequested.emit();
    }
}
